<nav class="header-container">
    <div class="logo"><img src="assets/logo-white.png"></div>
    <div class="site-menu">
        <ul role="menu">
            <li role="menuitem">
                <a href="../home/device-management" [class.selected]="isTabActive('device-management')">
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.9 16.45C15.25 16.45 16.35 15.35 16.35 14C16.35 12.65 15.25 11.55 13.9 11.55C12.54 11.55 11.45 12.65 11.45 14C11.45 15.35 12.54 16.45 13.9 16.45ZM19.1 14.68L20.58 15.84C20.71 15.95 20.75 16.13 20.66 16.29L19.26 18.71C19.17 18.86 19 18.92 18.83 18.86L17.09 18.16C16.73 18.44 16.33 18.67 15.91 18.85L15.64 20.7C15.62 20.87 15.47 21 15.3 21H12.5C12.32 21 12.18 20.87 12.15 20.7L11.89 18.85C11.46 18.67 11.07 18.44 10.71 18.16L8.96 18.86C8.81 18.92 8.62 18.86 8.54 18.71L7.14 16.29C7.05 16.13 7.09 15.95 7.22 15.84L8.7 14.68L8.65 14L8.7 13.31L7.22 12.16C7.09 12.05 7.05 11.86 7.14 11.71L8.54 9.29C8.62 9.13 8.81 9.07 8.96 9.13L10.71 9.84C11.07 9.56 11.46 9.32 11.89 9.15L12.15 7.29C12.18 7.13 12.32 7 12.5 7H15.3C15.47 7 15.62 7.13 15.64 7.29L15.91 9.15C16.33 9.32 16.73 9.56 17.09 9.84L18.83 9.13C19 9.07 19.17 9.13 19.26 9.29L20.66 11.71C20.75 11.86 20.71 12.05 20.58 12.16L19.1 13.31L19.15 14L19.1 14.68ZM4.69 6.07C5.56 6.07 6.26 5.37 6.26 4.5C6.26 3.63 5.56 2.92 4.69 2.92C4.27096 2.92 3.86908 3.08646 3.57277 3.38277C3.27646 3.67908 3.11 4.08096 3.11 4.5C3.11 5.37 3.82 6.07 4.69 6.07ZM8.03 4.94L9 5.68C9.07 5.75 9.09 5.87 9.03 5.97L8.13 7.53C8.08 7.63 7.96 7.67 7.86 7.63L6.74 7.18L6 7.62L5.81 8.81C5.79 8.92 5.7 9 5.59 9H3.79C3.67 9 3.58 8.92 3.56 8.81L3.4 7.62L2.64 7.18L1.5 7.63C1.41 7.67 1.3 7.63 1.24 7.53L0.34 5.97C0.28 5.87 0.310001 5.75 0.390001 5.68L1.34 4.94L1.31 4.5L1.34 4.06L0.390001 3.32C0.310001 3.25 0.28 3.13 0.34 3.03L1.24 1.47C1.3 1.37 1.41 1.33 1.5 1.37L2.63 1.82L3.4 1.38L3.56 0.19C3.58 0.0800001 3.67 0 3.79 0H5.59C5.7 0 5.79 0.0800001 5.81 0.19L6 1.38L6.74 1.82L7.86 1.37C7.96 1.33 8.08 1.37 8.13 1.47L9.03 3.03C9.09 3.13 9.07 3.25 9 3.32L8.03 4.06L8.06 4.5L8.03 4.94Z" fill="currentColor"/>
                    </svg>&nbsp;&nbsp;Asset Management
                </a>
            </li>
            <li role="menuitem">
                <a href="../home/customer-management/list" [class.selected]="isTabActive('customer-management')">
                    <i class="mr-3 fas fa-users icon"></i>
                    &nbsp;&nbsp;Customer Management
                </a>
            </li>
            <li role="menuitem">
                <a href="../home/iot-tool" [class.selected]="isTabActive('iot-tool')">
                    <i class="mr-3 fas fa-microchip icon"></i>
                    &nbsp;&nbsp;IoT Tool
                </a>
            </li>
        </ul>
    </div>
    <div class="header-buttons-container">
            <div class="header-button">
                <a (click)="toggleHelp(true)">
                    <i class="fas fa-question-circle"></i>
                </a>   
            </div>
            <div class="audit-log-link">
                <a [routerLink]="['/home/user-audit-log']" #rla="routerLinkActive" routerLinkActive="active">
                    <img [src]="
                        rla.isActive
                            ? 'assets/icons/audit-log-filled.svg'
                            : 'assets/icons/audit-log-outline.svg'
                    ">
                </a>   
            </div>
            <div class="header-button user-menu">
                <custom-dropdown-list-container [(isDropdownOpen)]="isUserMenuOpen">
                    <a dropdown-toggle>
                        <i class="fas fa-user"></i>
                    </a>
                    <div class="custom-dropdown-items custom-dropdown-light user-menu-items" dropdown-list>
                        <custom-menu-item [name]="'Logout'" (executeEvent)="logout()"></custom-menu-item>
                    </div>
                </custom-dropdown-list-container>
            </div>
    </div>
</nav>
